import { authStore } from "@features/auth/tess-session.store"
import { apiConfig } from "eddev/hooks"

apiConfig.customRPCFetchOptions = async (type, queryName, url, opts) => {
  if (queryName.startsWith("api.public.tess.")) {
    return {
      ...opts,
      headers: {
        ...opts.headers,
        authentication: "Bearer " + authStore.encryptedSessionKey,
      },
    }
  }

  return opts
}
